import { render } from "./Cur-order.vue?vue&type=template&id=1065d742&scoped=true"
import script from "./Cur-order.vue?vue&type=script&lang=js"
export * from "./Cur-order.vue?vue&type=script&lang=js"

import "./Cur-order.vue?vue&type=style&index=0&id=1065d742&scoped=true&lang=css"

import exportComponent from "/root/fixed-links/crm-updated/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1065d742"]])

export default __exports__